module.exports = __webpack_public_path__ + "assets/img/组 154@2x.a76c7979.png";